import { Flex, Text, Box } from '@chakra-ui/react';

import ToastStatusIcon from './ToastStatusIcon';

interface Properties {
  title: string;
  status: 'success' | 'error';
}

const CustomToast = ({ title, status }: Properties) => {
  return (
    <Flex
      align='center'
      gap='11px'
      py='11px'
      px='16px'
      borderRadius='12px'
      bgColor='#121826'
      boxShadow='0px 8px 24px rgba(0, 0, 0, 0.24)'
      overflowWrap='break-word'
    >
      <Box flexShrink={0}>
        <ToastStatusIcon status={status} size={20} />
      </Box>

      <Text fontFamily='Roboto Bold' fontWeight='700' fontSize='13px' color='white'>
        {title}
      </Text>
    </Flex>
  );
};

export default CustomToast;
